import { createFileRoute } from "@tanstack/react-router";
import { OnboardingForm } from "./-components/OnboardingForm";

export const Route = createFileRoute("/(public)/(auth)/onboarding")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section>
      <div className="margin-top px-4 mx-auto overflow-hidden relative w-fit">
        <OnboardingForm />
      </div>
    </section>
  );
}
